import { render } from "./Valid.vue?vue&type=template&id=1d773d80"
import script from "./Valid.vue?vue&type=script&lang=js"
export * from "./Valid.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__